import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTagPosts } from "./tagApi";

 export const fetchPostWithTags = createAsyncThunk("tag/allfetchTags", async (req) => {

   
    const url =`http://localhost:9000/blogs?tags_like=${req.reduce(
        (accumulator, currentValue) => accumulator + '&tags_like='+currentValue,
         req[0]
      )}`
      const posts = await getTagPosts(url);
      return posts?.data;
 
});
const initialState = {
    posts: [],
    isLoading: false,
    isError: false,
    error: "",
};

const postSlice = createSlice({
    name: "tagPosts",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchPostWithTags.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchPostWithTags.fulfilled, (state, action) => {
                state.isLoading = false;
                state.posts = action.payload;
            })
            .addCase(fetchPostWithTags.rejected, (state, action) => {
                state.isLoading = false;
                state.posts = [];
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default postSlice.reducer;